import { supabase } from '../firebase/config';

async function getAccessToken(): Promise<string> {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data.session?.access_token) {
    throw new Error('Not authenticated');
  }
  return data.session.access_token;
}

async function postJson(path: string, body: Record<string, unknown>, auth = false) {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (auth) {
    headers.Authorization = `Bearer ${await getAccessToken()}`;
  }

  const response = await fetch(path, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.error || 'Request failed');
  }
  return result;
}

export const authService = {
  forgotPassword(email: string) {
    return postJson('/api/auth-forgot-password', { email });
  },

  resetPassword(token: string, password: string) {
    return postJson('/api/auth-reset-password', { token, password });
  },

  changePassword(currentPassword: string, newPassword: string) {
    return postJson('/api/auth-change-password', { currentPassword, newPassword }, true);
  },

  requestEmailChange(newEmail: string) {
    return postJson('/api/auth-request-email-change', { newEmail }, true);
  },

  confirmEmailChange(token: string) {
    return postJson('/api/auth-confirm-email-change', { token });
  },
};
